var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"m-shadow"},[_c('v-row',_vm._l((_vm.chart_prop),function(chart,index){return _c('v-col',{key:index},[_c('BasicGauge',{attrs:{"chart_prop":chart}})],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }